<template>
<el-container style="min-height: 100%;">
    <el-main style="background-color: #fff;display: flex;flex-direction: column;">
        <div class="_flex">
			<el-date-picker v-model="batchSearch.created_time" type="date" size="small" placeholder="时间范围"/>
			<el-input placeholder="批次名称" v-model="batchSearch.name" size="small" style="width: 200px;margin-left: 10px;"/>
			<el-select v-model="batchSearch.tag" clearable class="w200 ml_10" size="small" placeholder="线索类型">
				<el-option v-for="(item,index) in tagArr" :key="index" :label="item.name" :value="item.code"> </el-option>
			  </el-select>
			<el-button size="small" style="margin-left: 10px;" @click="getBatchLists(1)">筛选</el-button>
			<el-button size="small" type="success" v-permit="'/admin/crm/batchAdd'" @click="createBatch">创建批次</el-button>
		</div>
		<div style="flex: 1;margin-top: 10px;">
			<el-table :data="list" height="100%" v-loading="tableLoading" stripe :header-cell-style="{ background:'#f5f5f5'}">
			    <el-table-column prop="id" label="批次">
					<template v-slot="{row}">
						<p><span class="_color">编号：</span>{{row.id}}</p>
						<p><span class="_color">名称：</span>{{row.name}}</p>
						<p><span class="_color">备注：</span>{{row.desc}}</p>
					</template>
				</el-table-column>
			    <el-table-column prop="id" label="操作">
					<template v-slot="{row}">
						<p><span class="_color">时间：</span>{{row.created_time}}</p>
						<p><span class="_color">操作：</span>{{row.admin ? row.admin.nick_name : ''}} {{row.admin && row.admin.phone ? row.admin.phone.slice(-4) : ''}}</p>
						<p><span class="_color">归属：</span>{{row.depart_name}}</p>
					</template>
				</el-table-column>
			    <el-table-column prop="id" label="数量">
					<template v-slot="{row}">
						<p><span class="_color">线索总量：</span>{{row.total}}</p>
						<p><span class="_color">删除数：</span>{{row.invaild}}</p>
						<p><span class="_color">有效率：</span>{{row.vaild_rate}}</p>
					</template>
				</el-table-column>
			    <el-table-column prop="id" label="分配">
					<template v-slot="{row}">
						<p><span class="_color">已分配：</span>{{row.assigned}}</p>
						<p><span class="_color">未分配：</span>{{row.left}}</p>
						<p><span class="_color">分配率：</span>{{row.assigned_rate}}</p>
					</template>
				</el-table-column>
			    <el-table-column prop="id" label="标签">
					<template v-slot="{row}">
						<p>{{row.tag_text}}</p>
						<p>{{row.source_text}}</p>
					</template>
				</el-table-column>
			    <el-table-column label="操作" width="220px">
                    <template v-slot="{row}">
                        <div class="_flex _f_fw">
                            <el-button size="mini" type="primary" v-permit="'/admin/crm/batchEdit'" @click="editBatch(row)">编辑</el-button>
                            <el-button size="mini" type="warning" v-permit="'/admin/crm/batchImport'" @click="openUp(row.id)">上传</el-button>
                            <el-popconfirm v-permit="'/admin/crm/batchDel'" @confirm="delBatch(row.id)" style="margin-left: 10px;" title="删除批次会删除该批次下的线索，请谨慎操作！" >
                                <el-button slot="reference" size="mini" type="danger">删除</el-button>
                            </el-popconfirm>
                        </div>
                    </template>
			    </el-table-column>
			</el-table>
		</div>
		
		<el-dialog title="创建批次" :visible="editVisible" width="600px" center @close="editVisible=false">
		  <el-form label-position="right" label-width="120px" :model="batchForm" class="pr_20">
		    <el-form-item label="批次名称：">
		      <el-input v-model="batchForm.name"></el-input>
		    </el-form-item>
		    <el-form-item label="备注说明：">
		      <el-input v-model="batchForm.desc"></el-input>
		    </el-form-item>
			<el-form-item label="归属部门：">
                <el-cascader v-model="batchForm.depart_id" :options="departArr" :props="{value:'id',label:'name',checkStrictly:true}" style="width: 100%;"></el-cascader>
		    </el-form-item>
		    <el-form-item label="标签：">
				<div class="_flex _f_ai">
					线索类型
					<el-select v-model="batchForm.tag" class="w_70 ml_10" placeholder="请选择">
					    <el-option v-for="(item,index) in tagArr" :key="index" :label="item.name" :value="item.code"> </el-option>
					</el-select>
				</div>
                <div class="_flex _f_ai" style="margin-top: 10px;">
					线索来源
					<el-select v-model="batchForm.source" class="w_70 ml_10" placeholder="请选择">
					    <el-option v-for="(item,index) in sourceArr" :key="index" :label="item.name" :value="item.code"> </el-option>
					</el-select>
				</div>
                <div class="_flex _f_ai" style="margin-top: 10px;">
					跟进状态
					<el-select v-model="batchForm.follow_state" class="w_70 ml_10" placeholder="请选择">
					    <el-option v-for="(item,index) in followStateArr" :key="index" :label="item.name" :value="item.code"> </el-option>
					</el-select>
				</div>
		    </el-form-item>
            <el-form-item label="支持手动录入:">
                <el-switch v-model="batchForm.is_manul" :active-value="1" :inactive-value="0"></el-switch>
		    </el-form-item>
		  </el-form>
            <span slot="footer">
                <el-button @click="editVisible=false">取 消</el-button>
                <el-button type="primary" @click="batchSubmit">确 定</el-button>
            </span>
		</el-dialog>
		
		<el-dialog title="上传线索文件" :visible="upVisible" width="680px" center @close="upVisible=false" :close-on-click-modal="false" :close-on-press-escape="false">
		  <el-form label-position="right" :model="upForm" label-width="80px">
			  <el-form-item label="文件：">
				  <div class="_flex _f_ai">
                    <el-upload :headers="{'Content-Type':'multipart/form-data'}" action="none" :show-file-list="false" class="file_uploader" :on-change="handleChange" :auto-upload="false" accept=".xlsx,.xls,.csv" ref="upload" >
                        <el-button size="small" type="primary">点击上传</el-button>
                        {{upForm.filename}}
                        <div slot="tip" class="el-upload__tip" style="font-size: 14px;">
                            <div>支持xlsx、xls和csv格式文件最大记录行数10万行 <a :href="downloadUrl" download="crmkehumuban.xlsx" class="blue ml_10">下载模板</a></div>
                            <div>推荐将编辑后的xlsx另存为csv格式再导入,csv文件内存占用更少,速度更快</div>
                        </div>
                    </el-upload>
				  </div>
			  </el-form-item>
			  <el-form-item label="选项：">
                <div style="display: flex;flex-direction: column;">
                    <el-checkbox v-model="upForm.is_del_repeat" :true-label="1" :false-label="0">与系统库电话号码重复时，则剔除</el-checkbox>
					<el-checkbox v-model="upForm.is_del_error" :true-label="1" :false-label="0">号码空缺或位数异常时，则剔除</el-checkbox>
                </div>
			  </el-form-item>
		    <div class="t_c mt_40">
                <el-button size="small" @click="upVisible=false" :disabled="uploading">取 消</el-button>
                <el-button size="small" type="primary" :loading="uploading" @click="upsubmit">{{uploading ? '上传中' : '确 定'}}</el-button>
		    </div>
		  </el-form>
		</el-dialog>
		
    </el-main>
    <el-footer class="foot" style="display: flex;align-items: center;background-color: #fff;">
        <div style="margin-left: auto;">
            <el-pagination background @size-change="batchSizeChange" :current-page="batchSearch.page" @current-change="batchPageChange" :page-size="batchSearch.limit" layout="total, sizes, prev, pager, next, jumper" :total="batchSearch.total"></el-pagination>
        </div>
    </el-footer>
</el-container>
</template>
<script>
import * as echarts from 'echarts';
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { DepartmentLists, batchLists, batchAdd, batchEdit, uploadFile, batchImport, batchDel } from "@/request/apis.js"
import base from "@/request/base.js"
export default{
    components: {
        fileUpload
    },
    data(){
        return {
            departArr:[],
            batchSearch: {
                page: 1,
                limit: 10,
                total: 0,
                created_time: [],
                name: '',
                tag: '',
            },
            tagArr: [],
            sourceArr: [],
            batchFormInit: {},
            batchForm: {
                name: '',
                desc: '',
                depart_id: [],
                tag: '',
                source: '',
                follow_state: '',
                is_manul: 0,
            },
            followStateArr: [],
            downloadUrl: base.domain + '/static/crmkehumuban.xlsx',
            fileList: [],
            uploading: false,
            upFormInit: {},
            upForm: {
                batch_id: 0,
                file: '',
                filename: '',
                is_del_repeat: 1,
                is_del_error: 1,
            },
            mutipartFile: {},

			name:'',
            tableLoading: false,
            list : [],
			editVisible : false,
			formData : {
				name : ''
			},
			upVisible : false,
        }
    },
	mounted() {
        this.batchFormInit = {...this.batchForm};
        this.upFormInit = {...this.upForm};
        this.getBatchLists();
	},
	methods:{
        async getBatchLists(page = 0){
            if(page){
                this.batchSearch.page = page;
            }
            this.tableLoading = true;
            var res = await batchLists(this.batchSearch);
            this.tableLoading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.list = res.data;
            this.batchSearch.total = res.count;
            this.tagArr = res.other.tag;
            this.sourceArr = res.other.source;
            this.followStateArr = res.other.follow_state;
        },
        batchPageChange(page){
            this.getBatchLists(page);
        },
        batchSizeChange(limit){
            this.batchSearch.limit = limit;
            this.getBatchLists(1);
        },
        createBatch(){
            this.batchForm = {...this.batchFormInit};
            this.getDepartmentLists();
            this.editVisible = true;
        },
        editBatch(row){
            this.batchForm = row;
            this.getDepartmentLists();
            this.editVisible = true;
        },
        async batchSubmit(){
            let depart_id = this.batchForm.depart_id;
            if (depart_id instanceof Array) {
                depart_id = depart_id.length > 0 ? depart_id[depart_id.length - 1] : 0;
            }
            var res = await batchAdd({...this.batchForm, depart_id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.editVisible = false;
            this.getBatchLists();
        },
        async getDepartmentLists(){
            var res = await DepartmentLists();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.departArr = res.data;
        },
        openUp(batch_id){
            this.mutipartFile = null;
            this.upForm = {...this.upFormInit, batch_id};
            this.upVisible = true;
        },
        handleChange(file) {
            this.mutipartFile = new FormData();
            this.mutipartFile.append("file", file.raw);
            this.upForm.filename = file.name;
        },
        async upsubmit(){
            if(!this.mutipartFile || !this.mutipartFile.get("file")){
                return this.$message.error("请选择文件");
            }
            this.mutipartFile.append("batch_id", this.upForm.batch_id);
            this.mutipartFile.append("is_del_repeat", this.upForm.is_del_repeat);
            this.mutipartFile.append("is_del_error", this.upForm.is_del_error);
            this.uploading = true;
            batchImport(this.mutipartFile).then(res => {
                this.uploading = false;
                if (res.code !== 0) {
                    return this.$message.error(res.msg || '未知错误');
                }
                this.$message.success(res.msg);
                this.upVisible = false;
                this.getBatchLists();
            }).catch(error => {
                this.uploading = false;
                console.log('errorrrr', error)
                return this.$message.error('请求失败：' + error.message);
            });
        },
        async delBatch(id){
            var res = await batchDel({id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.getBatchLists();
        }
	}
}
</script>

<style  scoped>
p{margin: 0;}
</style> 